module.exports = __webpack_public_path__ + "static/media/test3.b1d472f6.png";